import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import CrudForm, { FormConfiguration } from "../shared/crud/form";
import { useCampingMapService } from "./application/campingMap.service";
import { buildFormConfiguration, buildSchema } from "./campingMap.formConfig";
import { CampingMapEntity } from "./infraestructure/campingMap.dto";
import { campingMapMessages } from "./messages";

const FormContainer = styled("div")`
  .form-group.field.field-boolean {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
`;

function CampingMapForm({ propertyTicker }: { propertyTicker: string }) {
  const intl = useIntl();
  const { getOne, update } = useCampingMapService(propertyTicker);

  const handleGetOne = useCallback(() => getOne(), [getOne]);

  const validate = useCallback(
    (formData: CampingMapEntity, errors) => {
      if (formData.enabled && !formData.baseUrl) {
        errors.baseUrl.addError(intl.formatMessage(campingMapMessages.requiredValidationFailed));
      }
      return errors;
    },
    [intl]
  );

  const handleUpdate = useCallback(
    async (entity: CampingMapEntity) => {
      await update(entity);
      alert(intl.formatMessage(campingMapMessages.saveSuccess));
    },
    [update, intl]
  );

  const { formConfiguration, schema } = useMemo<{
    formConfiguration: FormConfiguration<CampingMapEntity>;
    schema: any;
  }>(
    () => ({
      schema: buildSchema(),
      formConfiguration: buildFormConfiguration(),
    }),
    []
  );

  return (
    <CrudForm<CampingMapEntity>
      id="campingMap"
      schema={schema}
      formConfiguration={formConfiguration}
      messages={campingMapMessages}
      onGet={handleGetOne}
      onUpdate={handleUpdate}
      container={FormContainer}
      enumsOptional
      liveValidate={false}
      validate={validate}
    />
  );
}

export default withAuthorizationVerifier(CampingMapForm);
